var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "expandableText" }, [
    !_vm.isExpandable || _vm.isExpanded
      ? _c(
          "span",
          { ref: "fullText", staticClass: "fullText" },
          [_vm._t("default")],
          2
        )
      : _c("span", [_vm._v(_vm._s(_vm.shortText))]),
    _vm._v(" "),
    _vm.isExpandable
      ? _c("span", { staticClass: "expandCollapseLinks" }, [
          _vm.isExpanded
            ? _c(
                "button",
                {
                  staticClass: "collapseLink buttonAsLink",
                  on: { click: _vm.toggle }
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.collapseText) + "\n        "
                  )
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "expandLink buttonAsLink",
                  on: { click: _vm.toggle }
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.expandText) + "\n        "
                  )
                ]
              )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }